import React from 'react';
import { useTranslation } from 'react-i18next';
import type { FormDataState } from '../../hooks/useCreateQuote';

interface TransportationMethodsSectionProps {
  formData: FormDataState;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  labelClass: string;
}

export const TransportationMethodsSection: React.FC<TransportationMethodsSectionProps> = ({
  formData,
  handleChange,
  labelClass
}) => {
  const { t } = useTranslation();
  const sectionTitleClass = "text-lg leading-none tracking-tight mb-4 text-foreground";

  return (
    <div>
      <h4 className={sectionTitleClass}>{t('quote.form.sections.transportation')}</h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {[
          { key: 'transportation_adr', label: t('quote.form.fields.transport_methods.adr') },
          { key: 'transportation_closed_truck', label: t('quote.form.fields.transport_methods.closed') },
          { key: 'transportation_crane_truck', label: t('quote.form.fields.transport_methods.crane') },
          { key: 'transportation_aog', label: t('quote.form.fields.transport_methods.aog') },
          { key: 'transportation_tarpaulin', label: t('quote.form.fields.transport_methods.tarpaulin') },
        ].map(({ key, label }) => (
          <label key={key} className="flex items-center space-x-3 space-y-0 rounded-md border border-border p-4 hover:bg-accent/50 transition-colors cursor-pointer">
            <input
              type="checkbox"
              name={key}
              checked={formData[key] as boolean}
              onChange={handleChange}
              className="h-4 w-4 rounded border-input text-foreground focus:ring-ring"
            />
            <span className="text-sm font-medium leading-none">{label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};
